import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    AlertColor,
    Select,
    TextField,
    MenuItem,
    FormControlLabel,
    Switch,
    InputAdornment,
    IconButton,
    InputLabel,
    FormControl,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import PageWrapper from "../../components/PageWrapper";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { defaultToast } from "../../helpers/toast/defaultToast";
import { api } from "../../services/api";
import { LIST_TYPES_DATABASES, LIST_CLOUD } from "./constants";
import { schemaForms } from "./schema";
import {
    Container,
    ContentInput,
    TitlePage,
    ContentButtonForm,
    Content,
    ContentRowInput,
} from "./styles";

type SchemaFormData = yup.InferType<typeof schemaForms>;

function NewManagerDatabasesPage() {
    const { control, handleSubmit, watch } = useForm<SchemaFormData>({
        resolver: yupResolver(schemaForms),
        defaultValues: {
            customer_database_type_id: LIST_TYPES_DATABASES[0].id,
            cloud: LIST_CLOUD[0].id,
            cluster_id: undefined,
            cluster_name: undefined,
            password: undefined,
            port: undefined,
            private_host: undefined,
            public_host: undefined,
            ssl_cert: undefined,
            ssl_enabled: false,
            username: undefined,
        },
    });

    const navigate = useNavigate();

    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            !hasPermissions("configuracoes.criar_gerenciamento_banco") &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    const enableSSLWatch = watch("ssl_enabled");

    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [openToast, setOpenToast] = useState(false);
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleCreateDatabase = async (data: SchemaFormData) => {
        try {
            setIsLoading(true);

            const responseCreateDatabase = await api.post(
                "clustersDatabases/createDatabase",
                {
                    cluster_name: data?.cluster_name,
                    customer_database_type_id: Number(
                        data?.customer_database_type_id
                    ),
                    password: data?.password,
                    port: Number(data?.port),
                    private_host: data?.private_host,
                    username: data?.username,
                    public_host: data?.public_host,
                    ssl_enabled: data?.ssl_enabled,
                    ssl_cert: data?.ssl_cert,
                    cloud: data?.cloud,
                    cluster_id: data?.cluster_id,
                }
            );

            if (responseCreateDatabase?.status) {
                defaultToast("success", "Banco de dados criado com sucesso");

                setTimeout(() => {
                    navigate("/settings/manager-databases");
                }, 2000);
            }
        } catch (error) {
            console.error(error);
            setOpenToast(true);
            setToastRequisitionResult("error");
            setTextToast("Erro ao criar banco de dados");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PageWrapper>
            <Container onSubmit={handleSubmit(handleCreateDatabase)}>
                <TitlePage>Novo Banco de Dados</TitlePage>
                <Content>
                    <div
                        style={{
                            width: "100%",
                        }}
                    >
                        <ContentRowInput>
                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="cluster_id"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="cluster_id"
                                            label="Id Cluster"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="cluster_name"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="cluster_name"
                                            label="Nome Cluster"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>
                        </ContentRowInput>

                        <ContentRowInput>
                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="public_host"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="public_host"
                                            label="Host Público"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="private_host"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="private_host"
                                            label="Host Privado"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>
                        </ContentRowInput>

                        <ContentRowInput>
                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="port"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="port"
                                            label="Porta"
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="username"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="username"
                                            label="Nome de Usuário"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="password"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="password"
                                            label="Senha"
                                            variant="outlined"
                                            size="small"
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={
                                                                handleClickShowPassword
                                                            }
                                                            edge="end"
                                                        >
                                                            {showPassword ? (
                                                                <VisibilityOff />
                                                            ) : (
                                                                <Visibility />
                                                            )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </ContentInput>
                        </ContentRowInput>

                        <ContentRowInput>
                            <ContentInput
                                style={{
                                    width: "auto",
                                    minWidth: "180px",
                                }}
                            >
                                <Controller
                                    control={control}
                                    name="ssl_enabled"
                                    render={({
                                        field: { value, onChange },
                                    }) => (
                                        <FormControlLabel
                                            control={<Switch value={value} />}
                                            label="Habilitar SSL"
                                            name="ssl_enabled"
                                            id="ssl_enabled"
                                            onChange={onChange}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="ssl_cert"
                                    render={({
                                        field: { value, name, ref, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <TextField
                                            fullWidth
                                            id="ssl_cert"
                                            label="Certificado SSL"
                                            variant="outlined"
                                            size="small"
                                            ref={ref}
                                            name={name}
                                            value={value}
                                            type="text"
                                            onChange={onChange}
                                            error={Boolean(error)}
                                            helperText={error && error.message}
                                            disabled={!enableSSLWatch}
                                        />
                                    )}
                                />
                            </ContentInput>

                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="customer_database_type_id"
                                    render={({
                                        field: {
                                            value = "1",
                                            name,
                                            ref,
                                            onChange,
                                        },
                                    }) => (
                                        <FormControl fullWidth>
                                            <InputLabel id="select-database-type-label">
                                                Tipo de Banco
                                            </InputLabel>
                                            <Select
                                                style={{
                                                    width: "100%",
                                                }}
                                                labelId="select-database-type-label"
                                                id="customer_database_type"
                                                label="Tipo de Banco"
                                                value={value}
                                                size="small"
                                                name={name}
                                                ref={ref}
                                                onChange={onChange}
                                            >
                                                {LIST_TYPES_DATABASES.map(
                                                    (typesDatabases) => {
                                                        return (
                                                            <MenuItem
                                                                key={
                                                                    typesDatabases?.id
                                                                }
                                                                value={
                                                                    typesDatabases?.id
                                                                }
                                                            >
                                                                {typesDatabases.name.toLocaleUpperCase()}
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </ContentInput>
                        </ContentRowInput>

                        <ContentRowInput>
                            <ContentInput>
                                <Controller
                                    control={control}
                                    name="cloud"
                                    render={({
                                        field: {
                                            value = "1",
                                            name,
                                            ref,
                                            onChange,
                                        },
                                    }) => (
                                        <FormControl fullWidth>
                                            <InputLabel id="select-cloud-label">
                                                Cloud
                                            </InputLabel>
                                            <Select
                                                style={{
                                                    width: "100%",
                                                }}
                                                labelId="select-cloud-label"
                                                id="cloud"
                                                label="Cloud"
                                                value={value}
                                                size="small"
                                                name={name}
                                                ref={ref}
                                                onChange={onChange}
                                            >
                                                {LIST_CLOUD.map((cloud) => {
                                                    return (
                                                        <MenuItem
                                                            key={cloud?.id}
                                                            value={cloud?.id}
                                                        >
                                                            {cloud.name.toLocaleUpperCase()}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </ContentInput>
                        </ContentRowInput>

                        <ContentButtonForm>
                            <PreloadButton
                                colorText="white"
                                background="var(--success)"
                                loading={isLoading}
                                text="Criar banco de dados"
                                type="submit"
                                sx={{
                                    whiteSpace: "nowrap",
                                    fontSize: "13px !important",
                                }}
                            />
                        </ContentButtonForm>
                    </div>
                </Content>

                <Toast
                    open={openToast}
                    onClose={() => setOpenToast(false)}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </Container>
        </PageWrapper>
    );
}

export default NewManagerDatabasesPage;
